import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-artwork-empty';
export var ID = 'icon-artwork-empty';
/* eslint-disable max-len */

export var SVGArtworkEmpty = function SVGArtworkEmpty() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 80 81"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    transform: "translate(-5080.000000, -171.000000)"
  }, React.createElement("g", {
    transform: "translate(128.000000, 176.000000)",
    stroke: "#A8A0A0",
    strokeWidth: "2"
  }, React.createElement("path", {
    d: "M5007.5,35.5039964 C5007.5,37.7129964 5005.709,39.5039964 5003.5,39.5039964 C5001.291,39.5039964 4999.5,37.7129964 4999.5,35.5039964 C4999.5,33.2949964 5001.291,31.5039964 5003.5,31.5039964 C5005.709,31.5039964 5007.5,33.2949964 5007.5,35.5039964 Z M4966,55.0039964 L4981.6,41.0039964 L5018,62.0039964 M4970.3635,17.9990964 C4972.2465,7.76109637 4981.2175,0.00409636688 4991.9995,0.00409636688 C5002.7825,0.00409636688 5011.7535,7.76109637 5013.6365,17.9990964 M4976.5339,18.0049964 C4978.1799,12.7199964 4982.2309,8.49499637 4987.4069,6.61099637 M4966,68.0036964 L5018,68.0036964 L5018,18.0036964 L4966,18.0036964 L4966,68.0036964 Z"
  })), React.createElement("g", {
    transform: "translate(119.000000, 170.000000)"
  }))));
};
/* eslint-disable max-len */

var ArtworkEmpty = function ArtworkEmpty(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGArtworkEmpty
  });
};

ArtworkEmpty.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default ArtworkEmpty;